import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { stylesCP } from "../../../src/styles/scheduleTelcelBillPayments";
import "../../../src/styles/scheduleTelcelBillPayments.css";
import GenericInput from "../molecules/GenericInput";
import GenericInputLabel from "../atoms/GenericInputLabel";
import {
  getMessage,
  isObjectEmpty,
  validateUserAgent,
} from "../organisms/utils";
import DomiciliationModal from "../molecules/DomiciliationModal";
import ButtonMiTelcel, {
  ButtonMiTelcelContenedor,
} from "../atoms/ButtonMiTelcel";
import GenericInputError from "../atoms/GenericInputError";
import {
  MAX_AMOUNT_SERVICE_PAYMENT,
  URL_APPLE_STORE,
  URL_PLAY_STORE,
} from "../../constants";
import * as sdkclaro from "@claropay/claro-pay-sdk-v2";
import { executeTaggeo } from "../../store/actions";
import {
  setDomiciliationReferenceValues,
  setFromActionValue,
  setMaxAmountValue,
} from "../../store/actions/domiciliation";
import DomiciliationResponseModal from "../molecules/DomiciliationResponseModal";
import ModalCardOk from "../molecules/ModalCardOk";
import ModalCardLoader from "../molecules/ModalCardLoader";
import { formatCurrency } from "../organisms/utils";
import { setTermsCheckboxValue } from "../../store/actions/domiciliation";
import { getDomiciliationWindowId } from "../organisms/utils";

class ScheduleTelcelBillPayments extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modalInformation: {},
      dateModalInformation: {},
      maxAmountModalInformation: {},
      openModalInformation: false,
      amountInputInfo: {
        pattern: "[0-9]*",
        inputMode: "text",
        type: "text",
        id: "maxAmount",
        name: "maxAmount",
        inputMode: "decimal",
        placeHolder: "Debe ser igual o mayor a tu pago habitual",
        min: this.props.history.location.state.amount,
        max: MAX_AMOUNT_SERVICE_PAYMENT,
        onlyRead: false,
      },
      dateInputInfo: {
        inputMode: "",
        type: "text",
        id: "date",
        name: "date",
        inputMode: "",
        placeHolder: "",
        onlyRead: true,
      },
      errorAmountInput: "",
      errordateInput: "",
      amountInputIsValid: true,
      idMessage: "",
      openModalUpdateApp: false,
      modalUpdateAppInformation: {},
      isNewDomiciliationReferenceRequest: false,
    };
  }

  formatCurrencyAmount = (amount) => {
    var regex = new RegExp(".*\\..*\\..*");
    let value = amount.replace(/[$]/g, "");
    if (regex.test(amount)) {
      value = amount.replace(/[$]/g, "").replace(".", "", 1);
    }
    const amountSplit = value.split(".");
    if (amountSplit[1] && amountSplit[1].length > 2) {
      value = value.slice(0, -1);
    }
    const valueAddCommas = this.addCommasCurrencyFormat(value);
    return amount === "$" ? valueAddCommas : "$" + valueAddCommas;
  };

  removeCommas = (text) => {
    return text.replace(/(,)/gm, "");
  };

  addCommasCurrencyFormat = (text) => {
    return text.replace(/(,)/gm, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  componentDidMount() {
    const {
      messages,
      messagesDomiciliation,
      executeTaggeo,
      history,
      paymentAmountFromUrl,
      goToDomiciliationForm,
      setMaxAmountValue,
    } = this.props;
    const { accountValue, tagServiceId } = history.location.state;

    if (goToDomiciliationForm && paymentAmountFromUrl) {
      setMaxAmountValue(
        formatCurrency.format(this.removeCommas(paymentAmountFromUrl)),
      );
    }
    this.setState({
      maxAmountModalInformation: getMessage(messages, "CP0013"),
    });
    setTimeout(() => {
      this.setState({
        dateModalInformation: getMessage(messagesDomiciliation, "CP0018"),
      });
    }, 250);
    setTimeout(() => {
      executeTaggeo({
        action: "View",
        step: "Domiciliar pagos",
        service: tagServiceId,
        cellphone_number: accountValue,
      });
    }, 500);
  }

  getStyles() {
    return stylesCP;
  }

  getCheckBoxId() {
    return "termsCheckCP";
  }

  openContract() {
    const {
      history,
      executeTaggeo,
      setFromActionValue,
      maxAmountValueFromStore,
    } = this.props;
    const { amount, tagServiceId, accountValue } = history.location.state;
    setFromActionValue("clickT&C");
    history.push({
      pathname: `/schedule-telcel-bill-payments-contract`,
      state: {
        minAmount: formatCurrency.format(this.removeCommas(amount)),
        maxAmount: formatCurrency.format(
          this.removeCommas(maxAmountValueFromStore.slice(1)),
        ),
        tagServiceId,
        accountValue,
      },
    });

    executeTaggeo({
      action: "Click Términos y condiciones",
      step: "Domiciliar pagos",
      service: tagServiceId,
      cellphone_number: accountValue,
    });
  }
  handleOnClickLabelIcon = (e, id) => {
    setTimeout(() => {
      this.setState({ openModalInformation: true });
    }, 200);
    const { executeTaggeo, history } = this.props;
    const { accountValue, tagServiceId } = history.location.state;
    let action = "";
    let idMessage = "";
    const { maxAmountModalInformation, dateModalInformation } = this.state;
    if (id === "maxAmount") {
      this.setState({
        modalInformation: maxAmountModalInformation,
        idMessage: "Monto máximo explicación",
      });
      action = "Click tootlip Monto";
      idMessage = "Monto máximo explicación";
    }
    if (id === "date") {
      this.setState({
        modalInformation: dateModalInformation,
        idMessage: "Fecha de pago explicación",
      });
      action = "Click tooltip Fecha pago";
      idMessage = "Fecha de pago explicación";
    }
    setTimeout(() => {
      executeTaggeo({
        action: action,
        step: "Domiciliar pagos",
        service: tagServiceId,
        cellphone_number: accountValue,
      });
    }, 600);
    setTimeout(() => {
      executeTaggeo({
        action: "View message",
        step: "Domiciliar pagos",
        service: tagServiceId,
        id_message: idMessage,
      });
    }, 900);
  };
  handleOnChangeInput = (e, type) => {
    const { setMaxAmountValue, setTermsCheckboxValue } = this.props;
    const { value, checked } = e.target;
    const { amount } = this.props.history.location.state;
    if (type === "maxAmount") {
      let msgError = "";
      let amountValueIsValid = true;
      const valueFromated = this.formatCurrencyAmount(value);
      setMaxAmountValue(valueFromated);
      if (valueFromated === "" || valueFromated === "$") {
        msgError = "Es necesario que ingreses un monto";
        amountValueIsValid = false;
      } else {
        const amountFloat = parseFloat(valueFromated.replace(/[$,]/g, ""));
        if (amountFloat < amount) {
          msgError = "Debe ser igual o mayor a tu pago habitual";
          amountValueIsValid = false;
        }
        if (amountFloat > MAX_AMOUNT_SERVICE_PAYMENT) {
          msgError = "Ingresa el monto total de tu factura";
          amountValueIsValid = false;
        }
      }
      this.setState({
        errorAmountInput: msgError,
        amountInputIsValid: amountValueIsValid,
      });
    }
    if (type === "terms") {
      setTermsCheckboxValue(checked);
    }
  };

  handleOnClickInput = (e) => {
    const {
      setFromActionValue,
      checkBalance: { cutoffDate, lastPaymentDate },
    } = this.props;
    setFromActionValue("clicDateInput");
    const params = {
      requestCode: "date_picker_response",
      cutoffDate,
      lastPaymentDate,
    };
    const url = {
      app: "startEventNoClose",
      to: "openDatepicker",
      parameters: JSON.stringify(params),
    };
    sdkclaro.getInstance().openNative(
      JSON.stringify(url),
      () => {},
      () => {},
    );
  };

  handleOnClickSubmit = () => {
    const {
      setDomiciliationReferenceValues,
      history,
      canCallNip,
      messages,
      executeTaggeo,
      datePickerValue,
      maxAmountValueFromStore,
      tcInputIsValid,
    } = this.props;
    if (canCallNip) {
      const { accountValue, tagServiceId } = history.location.state;
      const dateSplit = datePickerValue.split("/");
      setDomiciliationReferenceValues(
        accountValue,
        `${dateSplit[2]}/${dateSplit[1]}/${dateSplit[0]}`,
        parseFloat(this.removeCommas(maxAmountValueFromStore.slice(1))),
        tcInputIsValid,
      );
      executeTaggeo({
        action: "Click Programar",
        step: "Domiciliar pagos",
        service: tagServiceId,
        cellphone_number: accountValue,
      });
      const params = { requestCode: getDomiciliationWindowId("nip_response") };
      const url = {
        app: "startEventNoClose",
        to: "openValidateNip",
        parameters: JSON.stringify(params),
      };
      sdkclaro.getInstance().openNative(
        JSON.stringify(url),
        () => {},
        () => {},
      );
    } else {
      this.setState({
        openModalUpdateApp: true,
        modalUpdateAppInformation: getMessage(messages, "CP0021"),
      });
    }
    this.setState({ isNewDomiciliationReferenceRequest: true });
  };

  handleOnClickModal = () => {
    const { executeTaggeo, history } = this.props;
    const { tagServiceId } = history.location.state;
    const { idMessage } = this.state;
    this.setState({ openModalInformation: false });
    executeTaggeo({
      action: "Click message Entendido",
      step: "Domiciliar pagos",
      service: tagServiceId,
      id_message: idMessage,
    });
  };

  handleOnClickModalUpdateApp = (e) => {
    const { innerText } = e.target;
    if (innerText == "Hacerlo en otro momento") {
      window.history.back();
    }
    if (innerText == "Actualizar") {
      const linkInformation = JSON.stringify({
        app: "https",
        url:
          validateUserAgent() === "android" ? URL_PLAY_STORE : URL_APPLE_STORE,
      });
      sdkclaro.getInstance().openNative(
        linkInformation,
        () => {},
        () => {},
      );
    }
  };

  render() {
    const helpIcon = "./images/icono_interrogaci_n.png";
    const penIcon = "./images/icono_editar.png";
    const arrowIcon = "./images/dropdown_arrow.png";
    const helpIconCt = "./images/icono_editar.png";
    const styles = this.getStyles();
    const checkId = this.getCheckBoxId();
    const {
      isLoadingServiceDomiciliation,
      history,
      domiciliationReferenceResponseError,
      domiciliationReferenceResponse,
      datePickerValue,
      fromActionValue,
      maxAmountValueFromStore,
      tcInputIsValid,
      isLoadingBalanceTelcel,
      isContainerTelcel,
    } = this.props;
    const { accountValue } = history.location.state;
    const {
      container,
      title,
      formWrapper,
      termsWrapper,
      termsTextWrapper,
      termsText,
      termsTextLink,
      imgBillTelcel,
      textSubtitle,
      textPhoneNumber,
      phoneNumber,
      subtitle,
      subtitleWrapper,
      buttonWrapper,
      inputDateWrapper,
      inputContent,
    } = styles;
    const {
      modalInformation,
      openModalInformation,
      amountInputInfo,
      dateInputInfo,
      errorAmountInput,
      errordateInput,
      amountInputIsValid,
      openModalUpdateApp,
      modalUpdateAppInformation,
      isNewDomiciliationReferenceRequest,
    } = this.state;
    const dateSelectedValue =
      fromActionValue === "clickButtonDomiciliation" ? "" : datePickerValue;
    const formIsValid =
      amountInputIsValid && dateSelectedValue && tcInputIsValid;
    return (
      <div style={container}>
        <p style={title}>DOMICILIAR SERVICIO</p>
        <div style={formWrapper}>
          <div style={subtitleWrapper}>
            <div>
              <img
                src={"/images/icono_recarga.png"}
                alt="img_factura_telcel"
                style={imgBillTelcel}
              />
            </div>
            <div>
              <p style={subtitle}>
                <span style={textSubtitle}>Factura Telcel</span>
                <span style={textPhoneNumber}>Número celular: </span>
                <span style={phoneNumber}>{accountValue}</span>
              </p>
            </div>
          </div>
          <div>
            <div style={inputContent}>
              <GenericInputLabel
                isContainerTelcel={isContainerTelcel}
                showIcon={isContainerTelcel ? false : true}
                imgIcon={helpIcon}
                labelText={
                  isContainerTelcel
                    ? "Monto máximo por pago"
                    : "Monto máximo por pago:"
                }
                handleOnClickLabelIcon={this.handleOnClickLabelIcon}
                id={"maxAmount"}
                hasError={errorAmountInput ? true : false}
              />
              <GenericInput
                showIcon={true}
                imgInputIcon={helpIconCt}
                value={maxAmountValueFromStore}
                inputInfo={amountInputInfo}
                handleOnChangeInput={this.handleOnChangeInput}
                handleOnClickInput={() => {
                  return false;
                }}
                hasError={errorAmountInput ? true : false}
                isContainerTelcel={isContainerTelcel}
              />
              <GenericInputError
                isContainerTelcel={isContainerTelcel}
                error={errorAmountInput}
              />
            </div>
            <div style={inputDateWrapper}>
              <GenericInputLabel
                showIcon={true}
                imgIcon={helpIcon}
                imgIconSize={"20px"}
                labelText={"Elige tu fecha de pago:"}
                handleOnClickLabelIcon={this.handleOnClickLabelIcon}
                id={"date"}
              />
              <GenericInput
                showIcon={true}
                imgInputIcon={isContainerTelcel ? helpIconCt : arrowIcon}
                value={
                  dateSelectedValue && dateSelectedValue !== ""
                    ? `Tu pago es el ${
                        dateSelectedValue.split("/")[0]
                      } de cada mes`
                    : dateSelectedValue
                }
                inputInfo={dateInputInfo}
                handleOnClickInput={this.handleOnClickInput}
              />
              <GenericInputError
                isContainerTelcel={isContainerTelcel}
                error={errordateInput}
              />
            </div>
          </div>
          <div style={termsWrapper}>
            <div>
              <input
                type="checkbox"
                id={checkId}
                onChange={(e) => this.handleOnChangeInput(e, "terms")}
                checked={tcInputIsValid}
              />
              <label htmlFor={checkId}></label>
            </div>
            <div style={termsTextWrapper}>
              <span style={termsText}>
                Acepto la domiciliación a mi cuenta Claro Pay Inbursa. Consulta
                los &nbsp;
              </span>
              <span style={termsTextLink} onClick={() => this.openContract()}>
                Términos y Condiciones
              </span>
            </div>
          </div>
          <div style={buttonWrapper}>
            {!isContainerTelcel ? (
              <ButtonMiTelcel
                width={"90%"}
                margin={"auto"}
                padding={"13px 0px"}
                fontSize={"14px"}
                disabled={!formIsValid}
                isEnabled={formIsValid}
                onClick={() => this.handleOnClickSubmit()}
                style={{ fontFamily: "Amx-Bold", height: "44px" }}
              >
                {"Domiciliar"}
              </ButtonMiTelcel>
            ) : (
              <ButtonMiTelcelContenedor
                disabled={!formIsValid}
                active={formIsValid}
                onClick={() => this.handleOnClickSubmit()}
              >
                {"Domiciliar"}
              </ButtonMiTelcelContenedor>
            )}
          </div>
        </div>
        {modalInformation &&
        !isObjectEmpty(modalInformation) &&
        openModalInformation ? (
          <DomiciliationModal
            isOpen={openModalInformation}
            icon={modalInformation.data.icon}
            subject={modalInformation.data.subject}
            message={modalInformation.data.message}
            buttons={modalInformation.data.buttons}
            handleOnClick={this.handleOnClickModal}
          />
        ) : (
          <></>
        )}
        {openModalUpdateApp && modalUpdateAppInformation ? (
          <ModalCardOk
            isOpen={openModalUpdateApp}
            srcImage={modalUpdateAppInformation.data.icon}
            text={modalUpdateAppInformation.data.subject}
            textdetail={modalUpdateAppInformation.data.message}
            buttontext={modalUpdateAppInformation.data.buttons[0]}
            onclickModal={this.handleOnClickModalUpdateApp}
            fontSizeTitle={"18px"}
            fontFamilyTitle={"NunitoBold"}
            textLink={modalUpdateAppInformation.data.buttons[1]}
            fontFamilyLinkButton={"RobotoBold"}
          />
        ) : (
          <></>
        )}
        <ModalCardLoader
          isOpen={isLoadingServiceDomiciliation || isLoadingBalanceTelcel}
        />
        {isNewDomiciliationReferenceRequest &&
        (domiciliationReferenceResponseError ||
          !isObjectEmpty(domiciliationReferenceResponse)) ? (
          <DomiciliationResponseModal />
        ) : (
          <></>
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  const {
    domiciliationReducer: {
      messagesDomiciliation = [],
      canCallNip,
      isLoadingServiceDomiciliation,
      domiciliationReferenceResponseError,
      domiciliationReferenceResponse,
      goToDomiciliationForm,
      dateValueFromNativeDatePicker,
      fromActionValue,
      maxAmountValueFromStore,
    },
  } = state;
  const {
    messages = [],
    getPaymentAmountFromUrl,
    amountTelcelPospago,
    isContainerTelcel,
    isloadingGetAmountTelcelPospago,
  } = state.payments;
  return {
    messagesDomiciliation,
    messages,
    canCallNip,
    isLoadingServiceDomiciliation,
    domiciliationReferenceResponseError,
    domiciliationReferenceResponse,
    goToDomiciliationForm,
    tcInputIsValid: state.domiciliationReducer.tcInputIsValid,
    paymentAmountFromUrl: getPaymentAmountFromUrl,
    datePickerValue: dateValueFromNativeDatePicker,
    fromActionValue,
    maxAmountValueFromStore,
    checkBalance: amountTelcelPospago,
    isContainerTelcel,
    isLoadingBalanceTelcel: isloadingGetAmountTelcelPospago,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      executeTaggeo,
      setTermsCheckboxValue,
      setDomiciliationReferenceValues,
      setFromActionValue,
      setMaxAmountValue,
    },
    dispatch,
  );
}

ScheduleTelcelBillPayments = connect(
  mapStateToProps,
  mapDispatchToProps,
)(ScheduleTelcelBillPayments);

export default ScheduleTelcelBillPayments;
